import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CruiseEventsService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetCruiseEventsFiltered(
    startdate: string | undefined,
    enddate: string | undefined,
    region: string | undefined,
    theme: string | undefined,
    itinerary: string | undefined,
    shiplist: number[] = []
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const CruiseShipEventsInfo: JSON = <JSON>(<unknown>{
      startdate: startdate,
      enddate: enddate,
      region: region,
      theme: theme,
      itinerary: itinerary,
      shiplist: shiplist,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetEventsFiltered',
      JSON.stringify(CruiseShipEventsInfo),
      {
        headers: headers,
      }
    );
  }
}
